import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Toggle, RadioSelect } from '@keen.io/ui-core';
import { Container, PositionContainer, AlignmentContainer } from './LegendSettings.styles';
import Row from '../../../Row';
import Label from '../../../Label';
import { legendMotion } from './motion';
import { getLayoutForPosition } from './utils';
import { POSITION_SETTINGS, VERTICAL_ALIGNMENT_SETTINGS, HORIZONTAL_ALIGNMENT_SETTINGS } from './constants';

var LegendSettings = function LegendSettings(_ref) {
  var label = _ref.label,
      isEnabled = _ref.isEnabled,
      alignment = _ref.alignment,
      position = _ref.position,
      positionLabel = _ref.positionLabel,
      _onChange = _ref.onChange;
  return React.createElement(Container, null, React.createElement(Row, null, React.createElement(Label, null, label), React.createElement(Toggle, {
    isOn: isEnabled,
    onChange: function onChange(legendEnabled) {
      return _onChange({
        enabled: legendEnabled
      });
    }
  })), React.createElement(AnimatePresence, {
    initial: false
  }, isEnabled && React.createElement(motion.div, Object.assign({}, legendMotion, {
    style: {
      overflow: 'hidden'
    }
  }), React.createElement(Row, null, React.createElement(Label, null, positionLabel), React.createElement(PositionContainer, null, React.createElement(RadioSelect, {
    activeItem: position,
    items: POSITION_SETTINGS,
    onClick: function onClick(_ref2) {
      var value = _ref2.value;
      var position = value;

      _onChange({
        position: position,
        layout: getLayoutForPosition(position)
      });
    }
  })), alignment && React.createElement(AlignmentContainer, null, React.createElement(RadioSelect, {
    activeItem: alignment,
    items: ['left', 'right'].includes(position) ? VERTICAL_ALIGNMENT_SETTINGS : HORIZONTAL_ALIGNMENT_SETTINGS,
    onClick: function onClick(_ref3) {
      var value = _ref3.value;
      var alignment = value;

      _onChange({
        alignment: alignment
      });
    }
  }))))));
};

export default LegendSettings;